Wee.fn.make('footer', {
	init: function() {
		this.$private.init();
	}
}, {
	init: function() {
		this.$scope = $('ref:footer');
		this.$sections = $('ref:section', this.$scope);

		this.initEvents();
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:sectionToggle': {
				click: function(e, el) {
					var $el = $(el);

					scope.toggleSection($el.data('id'));

					$el.toggleActive();
				}
			},
			'ref:footerNewsletterInput': {
				focus: function() {
					$('ref:footerNewsletter').activate();
				},
				blur: function() {
					$('ref:footerNewsletter').deactivate();
				}
			}
		});
	},

	/**
	 * Show/hide footer navigation links
	 *
	 * @private
	 */
	toggleSection: function(id) {
		this.$sections.each(function(section) {
			var $section = $(section);

			if ($section.data('id') === id) {
				$section.toggleActive();
			}
		});
	}
});